import {
  getAuthFromLocalStorage,
  isUserAdmin,
  isUserDoctor,
  isUserPatient,
} from "@/utils/common.util";
import PendingTestKits from "@/containers/home/pending-testkits";
import PendingResultUpload from "@/containers/home/pending-result-upload";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHomePageStats } from "@/redux/actions/homeActions";
import { RootState } from "@/redux/reducers";
import HomeStats from "@/containers/home/home-stats";
import PendingSampleCollection from "@/containers/home/pending-sample-collection";
import { TestKitType } from "@/common/types";

const Home = () => {
  const { user } = getAuthFromLocalStorage();

  const dispatch: any = useDispatch();

  const {
    stats,
    kitsPendingSampleCollection,
    kitsPendingTesting,
    kitsPendingResultUpload,
  } = useSelector((state: RootState) => state.home);

  const updateStats = () => {
    dispatch(getHomePageStats());
  };

  useEffect(() => {
    dispatch(getHomePageStats());
  }, []);

  const checkIfStatsNonEmpty = (stats: any) => {
    return Object.keys(stats)
      .map((key) => stats[key])
      .some((value) => value > 0);
  };

  return (
    <div className="w-full px-4 md:px-8 py-4">
      <p className="text-2xl font-bold pb-4">
        Welcome {user?.name ? `${user.name}` : "User"}
      </p>
      <div className="grid grid-cols-6 gap-3">
        {isUserAdmin() && (kitsPendingTesting as TestKitType[]).length > 0 && (
          <div className="sm:col-span-3 md:col-span-2 col-span-6">
            <PendingTestKits updateStats={updateStats} />
          </div>
        )}
        {isUserAdmin() &&
          (kitsPendingResultUpload as TestKitType[]).length > 0 && (
            <div className="sm:col-span-3 md:col-span-2 col-span-6">
              <PendingResultUpload />
            </div>
          )}
        {isUserDoctor() &&
          (kitsPendingSampleCollection as TestKitType[]).length > 0 && (
            <div className="sm:col-span-3 md:col-span-2 col-span-6">
              <PendingSampleCollection updateStats={updateStats} />
            </div>
          )}
        {isUserPatient() &&
          stats.doctor_details &&
          stats.doctor_details?.name && (
            <div className="sm:col-span-3 md:col-span-2 col-span-6">
              <div className="w-full h-full flex flex-col border rounded-md">
                <p className="font-bold px-4 pt-4 pb-2 border-b">
                  Doctor Details
                </p>
                <div className="py-2 flex">
                  <p className="font-bold px-4 pr-2">Name:</p>
                  <p className="px-4 pl-2">{stats.doctor_details?.name}</p>
                </div>
              </div>
            </div>
          )}
        {Object.keys(stats).map((key) =>
          checkIfStatsNonEmpty(stats[key]) ? (
            <div key={key} className="sm:col-span-3 md:col-span-2 col-span-6">
              <HomeStats title={key} value={stats[key]} />
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Home;
